import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../../Components/Common/ChartsDynamicColor";

const CustomerLifeTimeValue = ({ dataColors }) => {
  // Get dynamic colors for the chart
  const chartColumnDistributedColors = getChartColorsArray(dataColors);

  const [chartData] = useState({
    series: [
      {
        name: "Danube Properties",
        data: [46, 57, 59, 54, 62, 58, 64, 60, 66],
      },
      {
        name: "Danube Home",
        data: [74, 83, 102, 97, 86, 106, 93, 114, 94],
      },
      {
        name: "Milano",
        data: [37, 42, 38, 26, 47, 50, 54, 55, 43],
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "bar",
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "45%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      colors: chartColumnDistributedColors,
      xaxis: {
        categories: [
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
        ],
      },
      yaxis: {
        title: {
          text: "$ (thousands)",
        },
      },
      grid: {
        borderColor: "#f1f1f1",
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "$ " + val + " thousands";
          },
        },
      },
    },
    // options: {
    //   chart: {
    //     height: 350,
    //     type: "bar",
    //     events: {
    //       click: function (chart, w, e) {
    //         // Handle click events if needed
    //       },
    //     },
    //   },
    //   colors: chartColumnDistributedColors,
    //   plotOptions: {
    //     bar: {
    //       columnWidth: "45%",
    //       distributed: false, // Bars are not distributed; they're grouped
    //     },
    //   },
    //   dataLabels: {
    //     enabled: false, // Disable data labels on bars
    //   },
    //   legend: {
    //     show: false, // Hide the legend
    //   },
    //   xaxis: {
    //     categories: [
    //       "Jan",
    //       "Feb",
    //       "Mar",
    //       "Apr",
    //       "May",
    //       "Jun",
    //       "Jul",
    //       "Aug",
    //       "Sep",
    //       "Oct",
    //       "Nov",
    //       "Dec",
    //     ],
    //     labels: {
    //       style: {
    //         colors: [], // Custom label colors
    //         fontSize: "12px",
    //       },
    //     },
    //   },
    // },
  });

  return (
    <ReactApexChart
      dir="ltr"
      className="apex-charts"
      options={chartData.options}
      series={chartData.series}
      type="bar"
      height={350}
    />
  );
};

export { CustomerLifeTimeValue };
